import filterTabs from 'helpers/enums/filters/tabs'

import completeFiltersTree from 'helpers/filter/completeFiltersTree'
import findFilter from 'helpers/filter/findFilter'

function generateBreadcrumb(storeFilters, currentTab, standards, slice = true) {

	const breadcrumbs = completeFiltersTree(storeFilters, standards)
		.map(filterId => findFilter(standards, filterId))
		.filter(item => item)
		.sort((a, b) => a.item_index - b.item_index)
		.map(item => item.originalText || item.text)


	if (slice && breadcrumbs.length && currentTab === filterTabs.REGULAR_TAB) {
		breadcrumbs.splice(0, 0, 'All Lessons')
	}

	return breadcrumbs
}

export {
	generateBreadcrumb,
}
